import React from 'react';

import { Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ImageAvatar } from 'components/Avatar';
import { ListCard } from 'components/Card';
import { paths } from 'routes';
import { isoToDateString } from 'utils/dateFormatter';

export const InvoicesListItem = ({ supplier_id, buyer_id, job_ad_id, fee, created_at, supplier, buyer, job_ad }) => {
  return (
    <ListCard
      sx={{
        '& .MuiTypography-body2': {
          fontSize: { md: '0.75rem', lg: '0.875rem' },
        },
        '& .MuiTypography-caption': {
          fontSize: { md: '0.625rem', lg: '0.75rem' },
        },
      }}
    >
      <Stack direction="row" alignItems="center" gap={1} flex={{ md: 1.7, xl: 1.7 }} pr={1}>
        <ImageAvatar img={supplier?.square_logo_url || ''} name={supplier?.Name} sx={{ alignSelf: 'center' }} />
        <Link component={RouterLink} to={paths.suppliersDetailsView(supplier_id)} underline="none" color="inherit">
          <Typography variant="caption" fontWeight={700}>
            Supplier
          </Typography>

          <Typography variant="body2" fontWeight={700}>
            {supplier?.Name}
          </Typography>
        </Link>
      </Stack>

      <Stack direction="row" alignItems="center" gap={1} flex={{ md: 1.7, xl: 1.7 }} pr={1}>
        <ImageAvatar img={buyer?.square_logo_url || ''} name={buyer?.Name} sx={{ alignSelf: 'center' }} />
        <Link component={RouterLink} to={paths.buyersDetailsView(buyer_id)} underline="none" color="inherit">
          <Typography variant="caption" fontWeight={700}>
            Buyer
          </Typography>

          <Typography variant="body2" fontWeight={700}>
            {buyer?.Name}
          </Typography>
        </Link>
      </Stack>

      <Stack justifyContent="center" flex={{ md: 1, lg: 0.8, xl: 0.6 }} pr={1}>
        <Link component={RouterLink} to={paths.jobAdsDetailsView(job_ad_id)} underline="none" color="inherit">
          <Typography variant="caption" fontWeight={700}>
            Job ID
          </Typography>

          <Typography variant="body2" fontWeight={700}>
            {job_ad?.PublicID}
          </Typography>
        </Link>
      </Stack>

      <Stack justifyContent="center" flex={{ md: 0.7, lg: 0.5, xl: 0.3 }} pr={1}>
        <Typography variant="caption" fontWeight={700}>
          Fee (SEK)
        </Typography>

        <Typography variant="body2" fontWeight={700}>
          {fee}
        </Typography>
      </Stack>

      <Stack justifyContent="center" flex={{ md: 1.5, lg: 1.1, xl: 0.6 }} pr={1}>
        <Typography variant="caption" fontWeight={700}>
          Date and time
        </Typography>

        <Typography variant="body2" fontWeight={700}>
          {isoToDateString(created_at, true)}
        </Typography>
      </Stack>
    </ListCard>
  );
};
